module.exports = __webpack_public_path__ + "media/home/purple-background-771c2cc3.png";